import { CoreActions, CORE_ACTION, DirectPermissions } from './core.actions';
import { LoginStatus } from './login.status';

import {
  CLP_ACTION,
  ClpActions,
  ClpInitConfig,
  LOGIN_ACTION,
  LoginActions,
  LoginAlertModel,
  LoginAlertType,
  ClpLoginResponse
} from '@seco/login';

export enum LoginUiState {
  form = 0,
  formOtp = 1,
  forgetPwd = 2,
  formDdna = 3,
  expiredPwd = 4,
  validatePwd = 5,
  sso = 6,
  formPhone = 7,
  formCode = 8
}

// TODO: redesign/refactor WebAppLoginState & DirectLoginState store models & move clpConfig to right place
export interface WebAppLoginState {
  clpConfig?: ClpInitConfig;
  loggedIn: boolean;
  webAppToken: string;
}

export interface DirectLoginState {
  _isLoading: boolean;
  clpConfig?: ClpInitConfig;
  loginStatus: LoginStatus;
  directToken?: string;
  code?: number;
  parameters?: any;
  clpResponse?: ClpLoginResponse;
  localeList?: any;
  profile?: any;
  permissions: DirectPermissions;
  sessionBanner: {
    shownBanner: boolean;
    counter: number;
  };
  uiState: LoginUiState;
  errorModel?: LoginAlertModel[];
}

export const coreInitialState: WebAppLoginState = {
  loggedIn: false,
  webAppToken: ''
};

export const coreInitialAdState: DirectLoginState = {
  _isLoading: false,
  loginStatus: LoginStatus.NONE,
  directToken: '',
  permissions: {},
  sessionBanner: {
    shownBanner: false,
    counter: 0
  },
  uiState: LoginUiState.form,
  errorModel: []
};

type AllLoginActions = CoreActions | ClpActions | LoginActions;

export function coreWebappReducer(state = coreInitialState, action: AllLoginActions): WebAppLoginState {
  switch (action.type) {
    case CORE_ACTION.WEBAPP_UPDATE_CLP_CONFIG:
      return Object.assign({}, state, {
        clpConfig: action['payload']
      });

    case CORE_ACTION.WEBAPP_USER_LOGGED_IN:
      return Object.assign({}, state, {
        loggedIn: true,
        webAppToken: action['payload'].token
      });

    default:
      return state;
  }
}

export function coreDirectReducer(state = coreInitialAdState, action: AllLoginActions): DirectLoginState {
  switch (action.type) {
    case LOGIN_ACTION.LOGIN_REQUEST_SSO:
      return { ...state, _isLoading: true, errorModel: [] };
    case LOGIN_ACTION.CHANGE_ACCOUNT:
      return {
        ...state,
        ...coreInitialAdState
      };
    case LOGIN_ACTION.OTP_NEEDED:
      return {
        ...state,
        uiState: LoginUiState.formOtp,
        errorModel: []
      };
    case LOGIN_ACTION.INIT_FORGET_PWD_FLOW:
      return {
        ...state,
        uiState: LoginUiState.forgetPwd
      };
    case LOGIN_ACTION.PHONE_NUMBER_NEEDED:
      return {
        ...state,
        uiState: LoginUiState.formPhone,
        errorModel: []
      };
    case LOGIN_ACTION.VALIDATION_CODE_NEEDED:
      return {
        ...state,
        uiState: LoginUiState.formCode,
        errorModel: []
      };

    case LOGIN_ACTION.ERROR_RECEIVED:
    case CLP_ACTION.ERROR_RECEIVED:
      return { ...state, _isLoading: false, errorModel: action['payload'] };
    case CLP_ACTION.OTP_ERROR_RECEIVED:
      return { ...state, _isLoading: false };

    case CORE_ACTION.INIT_LOCALE_LIST:
      return { ...state, localeList: action['payload'] };

    case CORE_ACTION.DIRECT_UPDATE_CLP_CONFIG:
      /*
       * Set login status below - is workaround for MMMW2-5321.
       * When user not logged in, and open new tab with specific link to inner page - he gets login page
       * And after login some magic happens:)
       * Login module calls additional init and override LoginStatus.LOGIN (user already logged in)
       * And user get wrong view. According login status flow it can't be init after login,
       * because it already initialized. So, code below not set INIT status, if LOGIN status is already in state.
       * */
      return {
        ...state,
        loginStatus: state.loginStatus === LoginStatus.LOGIN ? LoginStatus.LOGIN : LoginStatus.INIT,
        clpConfig: action['payload'],
        _isLoading: !(state.loginStatus === LoginStatus.NONE || state.loginStatus === LoginStatus.ERROR)
      };
    case CORE_ACTION.DIRECT_USER_LOGGED_IN:
      return { ...state, _isLoading: false, loginStatus: LoginStatus.LOGIN, profile: action['payload'].profile };

    case CORE_ACTION.CLP_UPDATE_RESPONSE:
      return { ...state, clpResponse: action['payload'], permissions: action['payload'].permissions };

    case CORE_ACTION.DIRECT_REGISTRATION:
      return { ...state, _isLoading: false, loginStatus: LoginStatus.REGISTRATION, code: action['payload'].code };

    // MMMW2-5810 TODO: uncomment when logout fixed
    // case CORE_ACTION.DIRECT_USER_LOGGED_OUT:
    // return { ...state, loginStatus: LoginStatus.LOGOUT, directToken: '', code: null, clpResponse: null, clpConfig: null };

    case CORE_ACTION.DIRECT_AGREEMENT:
      return {
        ...state,
        loginStatus: LoginStatus.AGREEMENT,
        code: action['payload'].code,
        parameters: action['payload'].parameters
      };

    case CORE_ACTION.DIRECT_SESSION_BANNER:
      return { ...state, _isLoading: false, sessionBanner: action['payload'] };

    case CORE_ACTION.DIRECT_USER_LOGIN_ERROR:
      return {
        ...state,
        _isLoading: false,
        loginStatus: LoginStatus.ERROR,
        directToken: '',
        code: action['payload'].code
      };

    case CORE_ACTION.DIRECT_JWT_GENERATED:
      return { ...state, directToken: action['payload'].token, code: action['payload'].code };

    case CORE_ACTION.DIRECT_REFRESH_PAGE:
      return {
        ...state,
        _isLoading: false,
        loginStatus: LoginStatus.LOGIN,
        directToken: action['payload'].token,
        code: action['payload'].code,
        profile: action['payload']['profile'],
        errorModel: []
      };

    default:
      return state;
  }
}
